import { useTranslation } from "react-i18next";

import BaseSkeleton from "@/components_v2/Skeleton/BaseSkeleton";
import BaseSkeletonGroup from "@/components_v2/Skeleton/BaseSkeletonGroup";
import { SKELETON_VARIANTS } from "@/components_v2/Skeleton/constants";

import "@/domains/certifications/components/styles.css";
import "../styles.css";
import "./styles.css";

const RAIL_ROWS = 3;

const ModuleSkeleton = () => {
  const { t } = useTranslation();

  return (
    <BaseSkeletonGroup
      label={t("labels.loading")}
      className="flex flex-col gap-500"
    >
      <div className="flex flex-col gap-400">
        <BaseSkeleton width="18rem" />

        <div className="flex flex-col gap-200">
          <BaseSkeleton width="12rem" height="var(--spacing-400)" />

          <BaseSkeleton width="28rem" height="var(--spacing-600)" />

          <BaseSkeleton width="16rem" />
        </div>
      </div>

      <div className="flex flex-col gap-400">
        <BaseSkeleton width="14rem" height="var(--spacing-500)" />

        <div className="module-layout flex gap-600">
          <div className="module-main flex flex-col gap-400">
            <section className="certification-card module-card module-card-body flex flex-col gap-400">
              <BaseSkeleton width="8rem" height="var(--spacing-400)" />

              <div className="flex flex-wrap gap-400">
                <div className="module-video flex flex-col gap-200">
                  <BaseSkeleton height="12rem" />

                  <BaseSkeleton variant={SKELETON_VARIANTS.TEXT} lines={2} />
                </div>

                <div className="module-video flex flex-col gap-200">
                  <BaseSkeleton height="12rem" />

                  <BaseSkeleton variant={SKELETON_VARIANTS.TEXT} lines={2} />
                </div>
              </div>
            </section>

            <section className="certification-card module-card module-card-body flex flex-col gap-400">
              <BaseSkeleton width="10rem" height="var(--spacing-400)" />

              <BaseSkeleton variant={SKELETON_VARIANTS.TEXT} lines={3} />
            </section>
          </div>

          <aside className="module-rail certification-card module-card module-card-body flex flex-col gap-400">
            <BaseSkeleton width="10rem" height="var(--spacing-400)" />

            {Array.from({ length: RAIL_ROWS }, (_, index) => (
              <BaseSkeleton
                key={index}
                variant={SKELETON_VARIANTS.TEXT}
                lines={2}
              />
            ))}

            <BaseSkeleton height="var(--spacing-600)" />
          </aside>
        </div>
      </div>
    </BaseSkeletonGroup>
  );
};

export default ModuleSkeleton;
